exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collapse-side {\n  margin-left: 50px !important;\n}\n.selecterror{\n  color: black;\n}\n.selecterror input {\n  border-color: red !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/main.component.css
// module id = ../../../../../src/app/main/main.component.css
// module chunks = main